import { useEffect, useState } from 'react'

/**
 * Contador regressivo em segundos, para desabilitar botões de reenvio.
 *
 * É proteção de UX contra reclique — a imposição real vive no backend
 * (`AuthService.issueResetCode`, 60 s por conta), que sobrevive a reload, aba
 * nova e curl. Este contador só evita que o usuário reclique achando que não
 * funcionou.
 *
 * Um `setTimeout` por tick, não `setInterval`: o efeito já roda a cada mudança
 * do valor, então o próprio estado é o relógio e não sobra intervalo órfão.
 *
 * Extraído quando apareceu o segundo chamador (FirstAccess e ForgotPassword).
 */
export function useCooldown(): [number, (seconds: number) => void] {
  const [left, setLeft] = useState(0)

  useEffect(() => {
    if (left <= 0) return
    const t = setTimeout(() => setLeft((s) => s - 1), 1000)
    return () => clearTimeout(t)
  }, [left])

  return [left, setLeft]
}
